const getArrayIntData = (data) => {
  return data.split(",").map((item) => parseInt(item));
};
export default getArrayIntData;
